import { ModelWithPolicy } from 'modules/core/lib/modelWithPolicy'

import CustomResourcesResourcePolicy from 'modules/custom_resources/store/models/policies/CustomResourcesResourcePolicy'

export interface IResource {
  [key: string]: any
}

class Resource extends ModelWithPolicy<IResource> {
  static urlRoot() {
    return '/custom_resources/resources'
  }

  get policy() {
    return new CustomResourcesResourcePolicy(this)
  }
}

export default Resource
